/* assets/cart-ui.js */
(function () {
  "use strict";

  if (window.CordsCartUI) return;

  let footerLoadingCount = 0;

  function getCartFooter() {
    return (
      document.querySelector(".cart__footer") ||
      document.querySelector(".cart-drawer__footer") ||
      null
    );
  }

  function getFooterSubtotalValue(footerEl) {
    return footerEl?.querySelector(".totals__subtotal-value > span") || null;
  }

  function getFooterLoadingOverlay(footerEl) {
    return footerEl?.querySelector(".loading-overlay") || null;
  }

  function setFooterLoadingState(isLoading) {
    const footerEl = getCartFooter();
    if (!footerEl) return;

    const subtotalValue = getFooterSubtotalValue(footerEl);
    const overlay = getFooterLoadingOverlay(footerEl);

    if (subtotalValue) {
      subtotalValue.classList.toggle("disabled", isLoading);
    }

    if (overlay) {
      overlay.classList.toggle("hidden", !isLoading);
    }
  }

  function getLineOverlay(lineEl) {
    return lineEl?.querySelector(".loading-overlay") || null;
  }

  function getButtonContent(button) {
    return button?.querySelector(".button__content") || null;
  }

  function getButtonSpinner(button) {
    return (
      button?.querySelector(".cart-popular-products-slider__slide-spinner") ||
      button?.querySelector(".loading-overlay__spinner") ||
      null
    );
  }

  window.CordsCartUI = {
    startFooterLoading() {
      footerLoadingCount += 1;
      setFooterLoadingState(true);
    },

    stopFooterLoading() {
      footerLoadingCount = Math.max(0, footerLoadingCount - 1);
      if (footerLoadingCount === 0) {
        setFooterLoadingState(false);
      }
    },

    resetFooterLoading() {
      footerLoadingCount = 0;
      setFooterLoadingState(false);
    },

    startButtonLoading(button) {
    if (!button) return;

    button.dataset.wasDisabled = button.disabled ? "1" : "0";

    button.classList.add("is-loading");
    button.setAttribute("aria-busy", "true");
    button.setAttribute("aria-disabled", "true");
    button.disabled = true;

    const content = getButtonContent(button);
    const spinner = getButtonSpinner(button);

    if (content) content.classList.add("hidden");
    if (spinner) spinner.classList.remove("hidden");
    },

    stopButtonLoading(button) {
    if (!button) return;

    button.classList.remove("is-loading");
    button.removeAttribute("aria-busy");
    button.removeAttribute("aria-disabled");

    const wasDisabled = button.dataset.wasDisabled === "1";
    delete button.dataset.wasDisabled;

    if (!wasDisabled) {
        button.disabled = false;
    }

    const content = getButtonContent(button);
    const spinner = getButtonSpinner(button);

    if (content) content.classList.remove("hidden");
    if (spinner) spinner.classList.add("hidden");
    },

    setLineLoading(lineEl, isLoading) {
      if (!lineEl) return;

      lineEl.classList.toggle("disabled", isLoading);

      const overlay = getLineOverlay(lineEl);
      if (overlay) {
        overlay.classList.toggle("hidden", !isLoading);
      }
    },

    withFooterLoading(fn) {
      this.startFooterLoading();
      return Promise.resolve()
        .then(fn)
        .finally(() => {
          this.stopFooterLoading();
        });
    },
  };
})();